import React from "react";
import Layout from "../layouts/Default";
import useApi from "../hooks/useApi";
import NotFound from "../pages/404";
import Tool from "../components/tools/Tool";
import MediumArticle from "../components/mediumArticles/MediumArticle";

const Tools = () => {
  const { data, loading } = useApi("/pages?slug=tools");
  const [page] = data ? data : [];
  const { data: tools } = useApi("/resource");
  const { data: readings } = useApi("/reading");

  if (!page && !loading) return <NotFound />;
  return (
    <Layout title={page ? page.title.rendered : "Tools"}>
      {page && (
        <div className="pTools">
          <div className="pTools_infos">
            <h1>{page.title.rendered}</h1>
            <p
              className="text -big"
              dangerouslySetInnerHTML={{ __html: page.content.rendered }}
            />
          </div>
          <div className="pTools_list">
            {tools &&
              Array.isArray(tools) &&
              tools.map(tool => <Tool {...tool} key={tool.id} />)}
          </div>
          {readings && Array.isArray(readings) && (
            <div className="pTools_readings">
              <h1>Reading</h1>
              <div className="pTools_list">
                {readings &&
                  readings.map(reading => (
                    <MediumArticle {...reading} key={reading.id} />
                  ))}
              </div>
            </div>
          )}
        </div>
      )}
    </Layout>
  );
};

export default Tools;
